<template>
  <div class="applicant-form">
    <validation-observer ref="validator" v-slot="{ invalid, handleSubmit }" tag="div">
      <t-form @submit.native.prevent="handleSubmit(submit)">
        <t-validation-wrapper
          vid="experience_tier"
          :name="$t('fields.experience')"
          rules="required"
          no-label
        >
          <t-radio-group>
            <t-radio
              v-for="option in options"
              :key="option.value"
              v-model="form.experience_tier"
              :native-value="option.value"
            >
              {{ $t(option.labelKey) }}
            </t-radio>
          </t-radio-group>
        </t-validation-wrapper>

        <slot name="footer" :invalid="invalid" :loading="loading" />
      </t-form>
    </validation-observer>
  </div>
</template>

<script>
import Vue from 'vue';
import FormBaseMixin from '../../FormBaseMixin';
import Applicant from '~/models/Applicant';
import ExperienceTierEnum from '~/enums/ExperienceTierEnum';

export default Vue.extend({
  mixins: [FormBaseMixin],

  props: {
    applicant: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    form: null,
    options: ExperienceTierEnum.all().map((tier) => ({
      value: tier.key,
      labelKey: tier.labelKey,
    })),
  }),

  created() {
    this.form = this.getForm(this.applicant);
  },

  methods: {
    async request(payload) {
      const model = await new Applicant({ id: this.applicant.id, ...payload }).patch();
      this.$emit('updated', model);

      return model;
    },

    getForm(model = null) {
      return {
        experience_tier: model?.experience_tier ?? '',
      };
    },

    getPayload() {
      return { ...this.form };
    },
  },
});
</script>
